(function () {
  'use strict';

  /* @ngdoc object
   * @name vcasset.vcsafe
   * @description
   *
   */
  angular
    .module('vcuser.vcuser', [
    ]);
}());
